
// 波兰语
export default {
    login_module: {
        Login: 'Zaloguj się',
        Register: 'Zarejestruj się',
        noAccount: 'Nie masz jeszcze konta?',
        hasAccount: 'Mam już konto',
        loginSuccess:'Zalogowano pomyślnie!',
        IAgree: 'Zgadzam się z',
        rememberMe: 'Zapamiętaj',
        lostPassword: 'Nie pamiętam hasła',
        send: 'Wyślij',
        userName: 'Nazwa użytkownika',
        mailAddress: 'Adres e-mail',
        pwdFormat: 'Twoje hasło musi mieć od 6 do 15 znaków i zawierać co najmniej 1 literę i 1 cyfrę.',
        pwdConfirmFormat: 'Hasła wprowadzone w obu polach nie są takie same.',
        pasConfirm: 'Potwierdzenie hasła',
        pleaseInput: 'Wprowadź proszę',
        name: 'Nazwa',
        inputName: 'Wprowadź proszę swoje imię i nazwisko',
        userNameFormat: 'Nazwa użytkownika może zawierać tylko znaki alfanumeryczne lub pojedyncze myślniki i nie może zaczynać się ani kończyć myślnikiem.',
        password: 'Hasło',
        email: 'E-mail',
        inputEmail: 'Wprowadź proszę adres e-mail',
        emailFormatError: 'Błąd formatu e-mail',
        enterEmail: 'Wprowadź swój adres e-mail, na który wyślemy instrukcję dotyczącą resetowania hasła.',
        selectCountry: 'Wybierz kraj',
        verificationCode: 'Kod weryfikacyjny',
        verificationFormat: 'Kod weryfikacyjny jest nieprawidłowy.',
        CountryRegion: 'Kraj/Region',
        inputPwd: 'Wprowadź proszę hasło',
        activationPrompt: 'Wyślemy e-mail z linkiem aktywacyjnym na podany adres. Proszę go aktywować w swojej skrzynce e-mail przed zalogowaniem się.',
    },
    overview_module: {
        //overview
        today: 'Dzisiaj',
        detectionQuantity: 'Liczba pomiarów',
        abnormalQuantity: 'Liczba pomiarów poza wyznaczonym zakresem',
        dailyDetection: 'Dzienna liczba pomiarów',
        detectionItems: 'Przedmioty do pomiaru',
        bloodSugar: 'glukoza',
        bloodKetones: 'ketony we krwi',
        uricAcid: 'kwas moczowy',
        lactate: 'mleczany',
        mailbox: 'Skrzynka e-mail',
        detectionTime: 'Czas pomiaru',
        detectionValue: 'Wartość pomiaru',
        unit: 'Jednostka',
        search: 'Szukaj',
        enterName: 'Wprowadź imię',
        gender: 'Płeć',
        male: 'Mężczyzna',
        female: 'Kobieta',
        date: 'data',
        //时段
        allGlucose: 'Wszystkie pomiary glukozy',
        midnight: 'Północ',
        earlyMorning: 'Na czczo',
        afterBreakfast: 'Po śniadaniu',
        beforeLunch: 'Przed obiadem',
        afterLunch: 'Po obiedzie',
        beforeDinner: 'Przed kolacją',
        afterDinner: 'Po kolacji',
        bedtime: 'Przed snem',
    },
    table: {
        all: 'Wszystkie',
        display: 'Wyświetl',
        records: 'wyników',
        unused: 'nieużywany',
        used: 'używany',
    },
    aside: {
        //侧边栏
        overview: 'Przegląd',
        myPatients: 'Moi pacjenci',
        personalInfo: 'Dane osobowe',
        allPatients: 'Wszyscy pacjenci',
        inviteCodes: 'Kody zaproszeń',
        code: 'kod',
        changePwd: 'Zmień hasło',
        allDoctors: 'Wszyscy lekarze',
        allAgent: 'Wszyscy agenci',
        allInviteCodes: 'Wszystkie kody zaproszeń',
        operations: 'Operacje',
        feedback: 'Opinie',
        software: 'Oprogramowanie',
    },
    footer: {
        service: 'Prywatność i Warunki korzystania z usług',
        support: 'Uzyskaj wsparcie',
    },
    patient_module: {
        //patient
        remind: 'Przypomnij',
        sendMsg: 'Wyślij wiadomość',
        DMType: 'Typ cukrzycy',
        lastUploadTime: 'Czas ostatniego przesłania',
        device: 'Urządzenie',
        lastMeasureTime: 'Ostatni czas pomiaru',
        country: 'Kraj',
        type1: 'Typ I',
        type2: 'Typ II',
        otherForms: 'Inny typ',
        GDM: 'Cukrzyca ciążowa',
        typePre: 'Stan przedcukrzycowy',
        typeSpecial: 'Specjalny typ',
    },
    patient_detail_module: {
        confirmationTime: 'Data diagnozy',
        addNote: 'Dodaj notatkę',
        enterNote: 'Wprowadź proszę informacje do notatki',
        editNote: 'Notatka redaktora',
        confirmDeleteNote: 'Czy na pewno chcesz usunąć notatkę?',
        unbind: 'Odłącz',
        table: 'Tabela',
        logbook: 'Dziennik',
        trends: 'Trendy',
        period: 'Okres',
        Days: 'Dni',
        other: 'Inne',
        AvgDailyRange: 'Średnia dzienna liczba pomiarów w zakresie',
        AvgDailyNo: 'Średnia dzienna liczba pomiarów glukometrem',
        readingRange: 'Pomiary w zakresie',
        avgBG: 'Średni poziom glukozy we krwi',
        DerivedFrom: 'Pochodzi z',
        BGMReadings: 'pomiary z glukometru | pomiarów z glukometru',
        weeks: 'Tygodnie',
        monday: 'Pon',
        tuesday: 'Wt',
        wednesday: 'Śr',
        thursday: 'Czw',
        friday: 'Pt',
        saturday: 'Sob',
        sunday: 'Niedz',
        group: 'Grupa',
        range: 'Zakres',
        avg: 'Średnia',
        min: 'Najniższa wartość',
        max: 'Najwyższa wartość',
        low: 'Niski',
        normal: 'Normalny',
        high: 'Wysoki',
        time: 'raz | razy',
        medicine: 'Leki',
        food: 'Jedzenie',
        sport: 'Sport',
        DMInfo: 'Informacje o cukrzycy',
        height: 'Wzrost',
        weight: 'Waga',
        PreMealSugarCtrlTgt: 'Cel glikemii przed posiłkiem',
        PostprandialSugarCtrlTgt: 'Cel glikemii po posiłku',
        info: 'informacje',
        useDevice: 'Urządzenie',
        associatedDoc: 'Dodany lekarz',
        associatedAgent: 'Powiązany agent',
        lastLoginTime: 'Czas ostatniego logowania',
        uploadMethod: 'Metoda przesyłania',
        addMethod: 'Metoda dodawania',
        manualAddition: 'Ręczne dodawanie',
        realTime: 'Czas rzeczywisty',
        historical: 'Historyczne pomiary',
        recordTime: 'Czas zapisu',
        dose: 'Dawka',
        type: 'Typ',
        calories: 'Kalorie',
        carbs: 'Węglowodany',
        proteins: 'Białka',
        fats: 'Tłuszcze',
        strength: 'Intensywność',
        duration: 'Czas trwania',
        sendCustomerConfirm: 'Wyślemy treść bezpośrednio do klienta, prosimy o jej potwierdzenie.',
        selectExportedTime: 'Wybierz zakres dat, które chcesz eksportować',
        from: 'od',
        to: 'do',
        verificationCode: 'Kod weryfikacyjny',
        verificationFormat: 'Kod weryfikacyjny jest nieprawidłowy.',
        DetectionStats: 'Statystyki pomiarów',
        addedToday: 'Dodane dzisiaj',
        addedWeek: 'Dodane w tym tygodniu',
        addedMonth: 'Dodane w tym miesiącu',
        remarksNoEmpty: 'Uwagi nie mogą być puste',
        selectTableTime: 'Wybierz zakres dat danych z tabeli, które chcesz wyświetlić',
        startDate: 'Data początkowa',
        endDate: 'Data końcowa',
        belowRange: 'Pomiary poniżej zakresu',
        inRange: 'Pomiary w zakresie',
        aboveRange: 'Pomiary powyżej zakresu',
        pleaseSelectTimeRange: 'Proszę wybrać zakres dat!',
    },
    weekdays: {
        Sun: 'Niedz',
        Mon: 'Pon',
        Tue: 'Wt',
        Wed: 'Śr',
        Thu: 'Czw',
        Fri: 'Pt',
        Sat: 'Sob',
    },
    info_module: {
        basicInfo: 'Podstawowe informacje',
        avatar: 'Zdjęcie',
        birthday: 'Data urodzenia',
        chooseDate: 'wybierz datę',
        selfIntro: 'Wprowadzenie',
        PEIntro: 'Informacje o doświadczeniu zawodowym',
        oldPwd: 'Stare hasło',
        newPwd: 'Nowe hasło',
        inputOldPwd: 'Wprowadź proszę stare hasło',
        inputNewPwd: 'Wprowadź proszę nowe hasło',
        inputPwdAgain: 'Wprowadź proszę ponownie hasło',
    },
    invite_module: {
        add: 'Dodaj',
        Use: 'Użyj',
        push: "E-mail",
        pushMail: 'Skrzynka mailowa',
        remarks: 'Uwagi',
        phone: 'Telefon komórkowy',
        pushPhone: 'Popychaj telefon \nkomórkowy',
        phoneInfo: 'Wyślemy kod zaproszenia na ten telefon. Proszę przypomnieć pacjentowi o sprawdzeniu.',
        creationTime: 'Czas utworzenia',
        action: 'Akcja',
        generateCode: 'Wygeneruj kod zaproszenia',
        codeInfo: 'Wyślemy wiadomość z kodem aktywacyjnym na adres e-mail. Przypomnij pacjentowi, aby go sprawdził.',
    },
    system_module: {
        welcome: 'Witaj @ {name}!',
        welcomeMsg: 'VivaGuard zapewni Ci lepszą kontrolę nad swoją cukrzycą. Teraz możesz zalogować się do aplikacji VivaGuard i rozpocząć rejestrowanie poziomu cukru we krwi.',
        changePwd: 'Zmień hasło',
        changePwdFor: 'Zmień hasło dla @{name}',
        pwdInfo: 'Hasło musi zawierać co najmniej jeden znak i cyfrę, a mieć minimalną długość 6 znaków.',
        resend: 'Prześlij ponownie',
        resendInfo: 'Twoja konto jeszcze nie jest aktywowane. Namierszymy Ci e-mail z kodem aktywacyjnym na Twoją zarejestrowaną adres e-mail.',
        actived: 'Czy ukończono aktywację?',
        toLogin: 'Kliknij, aby zalogować się!',
        resendSuccess: 'Przesłano ponownie!',
        resendFailed: 'Nie przesłano ponownie!',
    },
    operation: {
        promot: 'Wskazówka',
        edit: 'Edytuj',
        save: 'Zapisz',
        yes: 'tak',
        delete: 'Usuń',
        saveSend: 'Zapisz i wyślij',
        rePush: 'Wyślij ponownie',
        cancel: 'anuluj',
        exit: 'Wyloguj się',
        confirmExit: 'Czy potwierdzić wyjście?',
        confirmDelete: 'Czy potwierdzić usunięcie?',
        addSuccessed: 'Pomyślnie dodano!',
        editSuccessed: 'Pomyślnie zaktualizowano!',
        successfullyDelete: 'Pomyślnie usunięto!',
    },
    notification: {
        1000: 'Token wygasł',
        1001: 'Token wygasł',
        1002: 'Błąd systemu',
        1003: 'Błąd parametru!',
        1006: 'Błąd parametru!',
        1008: 'Wysłaliśmy do Twojego maila wiadomość aktywacyjną. Zaloguj się, po czym aktywuj ją w swoim skrzynce!',
        1026: 'Nie wysyłaj ponownie!!!',
        6000: 'Plik jest za duży!',
        100001: 'Konto już zarejestrowane!',
        100002: 'Email lub hasło są nieprawidłowe.',
        100004: 'Konto nie istnieje!',
        100005: 'Konto nie jest aktywowane!',
        100006: 'Wysyłanie maila nie powiodło się! Skrzynka mailowa została aktywowana!',
        100007: 'Konto jest zablokowane!',
        100008: 'Hasło jest nieprawidłowe!',
        100011: 'Wysyłanie maila nie powiodło się, proszę spróbować ponownie!',
        200000: 'Kod weryfikacyjny jest nieprawidłowy!'
    },
    back: "Powrót"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/pl.js